import { useNavigator } from '@repo/toolkit/use-navigator'
import Badge from '@repo/ui/badge'
import { Column } from '@repo/ui/data-table'
import { PlusIcon, SheetOutlineIcon } from '@repo/ui/icons'
import { useRef } from 'react'

import { API } from '../../api/apis.config'
import CountryFlag from '../../components/elements/country-flag'
import DynamicDataTable, { DynamicTableRef } from '../../components/elements/dynamic-table'
import UserNavBar from '../../components/elements/nav-bar'
import PeriodBadge from '../../components/elements/period-badge'
import { Paths } from '../../lib/constants/path'
import { YouthAndSportNumber } from '../../lib/types/models/youth-and-sport-number/youth-and-sport-number'

const YouthAndSportNumberListPage = () => {
  const tableRef = useRef<DynamicTableRef<YouthAndSportNumber>>(null)
  const { navigate, navigateWithEvent } = useNavigator()

  const columns: Column<YouthAndSportNumber>[] = [
    {
      accessorKey: 'period.name',
      header: 'Période',
      enableSorting: true,
      cell: ({ row }) => (
        <PeriodBadge period={row.original.period} text={row.original.period.name} />
      )
    },
    {
      accessorKey: 'country.name',
      header: 'Pays',
      enableSorting: true,
      cell: ({ row }) => <CountryFlag code={row.original.country.code} />
    },
    {
      accessorKey: 'number',
      header: "N° d'enregistrements",
      enableSorting: true,
      cell: ({ row }) => <Badge text={row.original.number} variant="primary" />
    },
    {
      accessorKey: 'centers',
      header: 'Centre',
      cell: ({ row }) => {
        if (!row.original.centers.length) return '-'
        return (
          <div className="flex flex-wrap gap-2">
            {row.original.centers.map((center) => (
              <Badge key={center.id} text={center.name} variant="grey" />
            ))}
          </div>
        )
      }
    }
  ]

  return (
    <div>
      <UserNavBar title="N° d'enregistrements Jeunesse et Sport" icon={SheetOutlineIcon} />
      <div className="h-4" />
      <DynamicDataTable<YouthAndSportNumber>
        ref={tableRef}
        title="Tous les N° d'enregistrements Jeunesse et Sport"
        columns={columns}
        deleteMessage={{ name: "N° d'enregistrements", attributeName: 'number' }}
        selectable
        allowSearchParam
        endpoint={API.youthAndSportNumbers.getAll.url}
        onRowClick={(data, event) =>
          navigateWithEvent(
            Paths.YOUTH_AND_SPORT_NUMBER_UPDATE_PAGE.replace(':id', data.id.toString()),
            event
          )
        }
        actions={[
          {
            type: 'global',
            icon: PlusIcon,
            label: "Créer un N° d'enregistrements",
            fn: () => navigate(Paths.YOUTH_AND_SPORT_NUMBER_CREATE_PAGE)
          }
        ]}
      />
    </div>
  )
}

export default YouthAndSportNumberListPage
